<div class="row">
    <div class="title col-xs-9">
        {{ "catalog_pagination_next_page_title" | translate | uppercase }}
    </div>
    <div class="col-xs-3 text-right">
        <sp-switch [active]="isShowButton.value" (toggleActiveEvent)="setIsShowButton($event)"></sp-switch>
    </div>
</div>

@if (isShowButton.value) {
    <div class="form-row">
        <div class="form-group mb-20" [class.has-error]="isEmptyLabel">
            <label class="col-xs-12">
                {{ "control_text" | translate }}
            </label>
            <div class="col-xs-12">
                <input class="form-control" [formControl]="label" />
                @if (isEmptyLabel) {
                    <span class="help-block small">
                        {{ "control_errors_required" | translate }}
                    </span>
                }
            </div>
        </div>
        <div class="form-group mb-20">
            <label class="col-xs-12">
                {{ "control_style" | translate }}
            </label>
            <div class="col-xs-6">
                <select class="form-control" [formControl]="styleType">
                    <option [ngValue]="EButtonStyleType.primary">{{ "control_appearance_primary" | translate }}</option>
                    <option [ngValue]="EButtonStyleType.secondary">
                        {{ "control_appearance_secondary" | translate }}
                    </option>
                    <option [ngValue]="EButtonStyleType.custom">{{ "control_appearance_custom" | translate }}</option>
                </select>
            </div>
            <div class="col-xs-6">
                <div class="btn-group d-flex">
                    <sp-radio-group
                        [selected]="size.value"
                        [type]="ERadioGroupType.size"
                        (changeSelectedEvent)="setSize($event)"
                    ></sp-radio-group>
                </div>
            </div>
        </div>
        @if (styleType.value === EButtonStyleType.custom) {
            <sp-custom-button
                showHoverSettings
                [parentBase]="buttonBase.value"
                [parentHover]="buttonHover.value"
                [colorsPreset]="selectedThemeColors()"
                [buttonMode]="ButtonMode.light"
                (valueChangeEvent)="customButtonChangeHandler($event)"
            ></sp-custom-button>
        }
        <div>
            <sp-button-icon [buttonIcon]="buttonIcon.value" (valueChangeEvent)="buttonIconChangeHandler($event)">
            </sp-button-icon>
        </div>
        <div>
            <sp-button-additional-effects-settings
                [additionalEffects]="additionalEffects.value"
                (valueChangeEvent)="additionalEffectsChangeHandler($event)"
            >
            </sp-button-additional-effects-settings>
        </div>
    </div>
}
